import React, { memo } from 'react';
import { StoryblokRichtext } from 'storyblok-rich-text-react-renderer';
import { withBlokWrapper } from '../../BlokWrapper/BlokWrapper';
import { Theme } from '../../../interfaces/enums/Theme.enum';
import RichText from '../../RichText/RichText';

interface SubmitFormSectionLegalCopyProps {
  legal_copy: StoryblokRichtext;
}

const SubmitFormLegalCopy: React.FC<SubmitFormSectionLegalCopyProps> = ({
  legal_copy,
}) => {
  return (
    <div className="p-10 prose-a:text-text/body-primary-highlight prose-a:font-bold prose-a:no-underline">
      <RichText content={legal_copy} />
    </div>
  );
};

export default memo(withBlokWrapper(SubmitFormLegalCopy, Theme.DARK));
